import { cn } from "../../lib/cn"

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-block size-4 animate-spin rounded-full border-2 border-text-muted border-t-text-primary",
        className,
      )}
      role="status"
      aria-label="loading"
    />
  )
}
